export const programsAndPricingStyles = {
  gap: 3,
  flex: 1,
  minWidth: 0,
  minHeight: 0,
  alignSelf: 'flex-start',
  height: '100%',
  width: '100%',
  p: 3,
};

export const programsWrapperStyles = {
  gap: 1.25,
  width: '100%',
};

export const programsContentWrapperStyles = {
  gap: 1.25,
  minWidth: 0,
  minHeight: '50%',
  overflow: 'hidden',
};

export const programsTableScrollWrapperStyles = {
  overflow: 'auto',
  flex: 1,
  minHeight: 0,
};

export const programsTableInnerStyles = {
  width: 'max-content',
  minWidth: '100%',
};

export const tableHeadRowStyles = { height: 88 };

export const hiddenFilterPanelStyles = { visibility: 'hidden', height: 0, overflow: 'hidden' };
